<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading") Save
    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5(style="overflow: hidden")
          app-full-entity(:entity="entity", :ignoreTabs="orderIgnoreTabs",)
            template(v-slot:actionRoles="props")
              app-entity-relation(
                v-bind="props"
              )
                template(v-slot:EntityRelation="{ path }")
                  g-action-roles(:path="path", :entity="actionRoleEntity")
</template>

<script>
import axios from 'axios'
import EntityMixin from '@/mixins'

export default {
  mixins: [EntityMixin],
  name: 'entity-add',
  data: function () {
    return {
      loading: true,
      // instance: {
      //   orderLines: [],
      //   comments: [],
      //   user: this.$store.state.user.user,
      // },
      general: {},
      errors: {},
      processes: [],
      filesToUpload: [],

      loadingComment: false,
      comment: null,
      comments: [],

      permIgnore: ['businessScope', 'OrderType', 'OrderStatus', 'OrderComments', 'OrderContacts', 'iScope'],
      onAddIgnore: [''],

      menu2: false,
      date: null,
    }
  },
  computed: {
    entityName () {
      return 'Role'
    },
    entity () {
      return this.$findEntity('Role')
    },
    actionRoleEntity() {
      return this.$findEntity('ActionRole')
    },
    uid () {
      return this.$route.params.item
    },
    orderIgnoreTabs() {
      return [...this.permIgnore, ...(this.uid ? [] : this.onAddIgnore)];
    },
  },
  methods: {
    log(val) {
      console.log(val);
    },

    /* TODO: docs */
    async save () {
      // return console.debug('INSTANCE', this.instance)
      try {
        this.loading = true
        // TODO Fix on back end the recursivity here because it was never touched
        let _instance = { ...this.instance };
        _instance.actionRoles = _.chain(_instance)
          .thru(x => x.actionRoles || [])
          .map(x => ({ ...x, businessScope: null }))
          .value();
        // TODO Fix entity not linked properly (change name doesn t change to modified)
        _instance.entityState = _instance.entityState !== 4 ? 3 : 4;
        await axios.post('entity/graph', _instance);
        this.$updateSchema(this.$store, axios);
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      } finally {
        this.loading = false
      }
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, 'ExtraData')
          this.instance = (await axios.get(endpoint, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        this.loading = false;
      }
    },
  },
  created() {
    this.$store.commit('SET_INSTANCE', { entityState: 4, _Entity: this.entity.name })
  },
  async mounted () {
    await this.load()
  },
}
</script>
